<template>
  <section class="content-area responsive-content area-padding">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center mb--80">
          <h3>Un modelo con <span class="primary">mejoras constantes</span>.</h3>
          <p class="body-font1">
            El compromiso de RedGirasol con nuestra comunidad se mantiene firme: ofrecer atractivos proyectos de inversión, maximizando el alto impacto (ambiental y social) y minimizando el riesgo. Esto lo hemos logrado al desarrollar un modelo de riesgo crediticio que está en constante evolución y que a lo largo del tiempo nos ha ayudado a disminuir el porcentaje de nuestra cartera vencida.
          </p>
        </div>
        <!-- end avivon-heading -->
        <div class="avivon-heading">
          <h3 class="avivon__title col-sm-12">Cartera <span class="primary">vencida</span>. </h3>
          <p class="body-font1">
            A continuación, podrás consultar una tabla comparativa del impacto que nuestro modelo de evaluación de
            proyectos ha tenido en nuestra cartera a lo largo del tiempo de operación de RedGirasol, ya sea en cantidad de
            proyectos o en el monto que representan.
          </p>
        </div>
        <!-- end avivon-heading -->
      </div>
      <div class="row hidden-xs hidden-sm">
        <div class="col-sm-9">
          <div class="card card-table" style="margin-right:0px">
            <!---->
            <!---->
            <div class="mb-0 table-responsive">
              <table role="table" aria-busy="false" aria-colcount="5" class="table b-table">
                <caption aria-hidden="true" v-if="false">Cartera vencida</caption>
                <!---->
                <!---->
                <thead role="rowgroup" class="">
                  <!---->
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">

                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      Modelo 3
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3" class="">
                      Modelo 2
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="4" class="">
                      Modelo 1
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <!---->
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Fecha de uso</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="">
                      Dic 2020 - Presente
                    </td>
                    <td aria-colindex="3" role="cell" class="">
                      Abr 2020 - Nov 2020
                    </td>
                    <td aria-colindex="4" role="cell" class="">
                      Mar 2017 - Mar 2020
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Créditos considerados</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      <!-- <em class="fas fa-circle text-info"></em> -->
                      <em class="fas fa-circle primary"></em>
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      <em class="fas fa-circle primary"></em>
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      <em class="fas fa-circle primary"></em>
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Proyectos fondeados</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      {{this.modelo_03.projects_funded_number}}
                      ({{ moneyFormat(this.modelo_03.projects_funded_amount) }})
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      {{this.modelo_02.projects_funded_number}}
                      ({{ moneyFormat(this.modelo_02.projects_funded_amount) }})
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      {{this.modelo_01.projects_funded_number}}
                      ({{ moneyFormat(this.modelo_01.projects_funded_amount) }})
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Proyectos vencidos</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      {{this.modelo_03.projects_funded_fall_due_number}}
                      ({{ moneyFormat(this.modelo_03.projects_funded_fall_due_amount) }})
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      {{this.modelo_02.projects_funded_fall_due_number}}
                      ({{ moneyFormat(this.modelo_02.projects_funded_fall_due_amount) }})
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      {{this.modelo_01.projects_funded_fall_due_number}}
                      ({{ moneyFormat(this.modelo_01.projects_funded_fall_due_amount) }})
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Cartera vencida (en proyectos)</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_03.projects_funded_percent_number) }}
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_02.projects_funded_percent_number) }}
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_01.projects_funded_percent_number) }}
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Cartera vencida (en dinero)</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_03.projects_funded_percent_amount) }}
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_02.projects_funded_percent_amount) }}
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_01.projects_funded_percent_amount) }}
                    </td>
                  </tr>
                  <!---->
                  <!---->
                </tbody>
                <!---->
              </table>
            </div>
            <!---->
            <!---->
          </div>
        </div>
        <div class="col-sm-3">
          <div class="card card-table" style="margin-left:0px">
            <!---->
            <!---->
            <div class="mb-0 table-responsive">
              <table role="table" aria-busy="false" aria-colcount="5" class="table b-table">
                <caption aria-hidden="true" v-if="false">Cartera vencida</caption>
                <!---->
                <!---->
                <thead role="rowgroup" class="" style="background-color:#C2C2C3">
                  <!---->
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      Acumulado
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <!---->
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      Mar 2017 - Presente
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      <!-- <em class="fas fa-circle text-info"></em> -->
                      <em class="fas fa-circle primary"></em>
                    </td>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      {{this.modelo_acumulado.projects_funded_number}}
                      ({{ moneyFormat(this.modelo_acumulado.projects_funded_amount) }})
                    </td>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      {{this.modelo_acumulado.projects_funded_fall_due_number}}
                      ({{ moneyFormat(this.modelo_acumulado.projects_funded_fall_due_amount) }})
                    </td>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_acumulado.projects_funded_percent_number) }}
                    </td>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_acumulado.projects_funded_percent_amount) }}
                    </td>
                  </tr>
                  <!---->
                  <!---->
                </tbody>
                <!---->
              </table>
            </div>
            <!---->
            <!---->
          </div>
        </div>
      </div>
      <div class="row hidden-md hidden-lg">
        <div class="col-xs-12">
          <div class="card card-table">
            <!---->
            <!---->
            <div class="mb-0 table-responsive">
              <table role="table" aria-busy="false" aria-colcount="5" class="table b-table">
                <caption aria-hidden="true" v-if="false">Cartera vencida</caption>
                <!---->
                <!---->
                <thead role="rowgroup" class="">
                  <!---->
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">

                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      Modelo 3
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3" class="">
                      Modelo 2
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="4" class="">
                      Modelo 1
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="1" class="" style="background-color:#C2C2C3">
                      Acumulado
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <!---->
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Fecha de uso</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="">
                      Dic 2020 - Presente
                    </td>
                    <td aria-colindex="3" role="cell" class="">
                      Abr 2020 - Nov 2020
                    </td>
                    <td aria-colindex="4" role="cell" class="">
                      Mar 2017 - Mar 2020
                    </td>
                    <td aria-colindex="4" role="cell" class="">
                      Mar 2017 - Presente
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Créditos considerados</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      <!-- <em class="fas fa-circle text-info"></em> -->
                      <em class="fas fa-circle primary"></em>
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      <em class="fas fa-circle primary"></em>
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      <em class="fas fa-circle primary"></em>
                    </td>
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      <!-- <em class="fas fa-circle text-info"></em> -->
                      <em class="fas fa-circle primary"></em>
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Proyectos fondeados</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      {{this.modelo_03.projects_funded_number}}
                      ({{ moneyFormat(this.modelo_03.projects_funded_amount) }})
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      {{this.modelo_02.projects_funded_number}}
                      ({{ moneyFormat(this.modelo_02.projects_funded_amount) }})
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      {{this.modelo_01.projects_funded_number}}
                      ({{ moneyFormat(this.modelo_01.projects_funded_amount) }})
                    </td>
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      {{this.modelo_acumulado.projects_funded_number}}
                      ({{ moneyFormat(this.modelo_acumulado.projects_funded_amount) }})
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Proyectos vencidos</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      {{this.modelo_03.projects_funded_fall_due_number}}
                      ({{ moneyFormat(this.modelo_03.projects_funded_fall_due_amount) }})
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      {{this.modelo_02.projects_funded_fall_due_number}}
                      ({{ moneyFormat(this.modelo_02.projects_funded_fall_due_amount) }})
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      {{this.modelo_01.projects_funded_fall_due_number}}
                      ({{ moneyFormat(this.modelo_01.projects_funded_fall_due_amount) }})
                    </td>
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      {{this.modelo_acumulado.projects_funded_fall_due_number}}
                      ({{ moneyFormat(this.modelo_acumulado.projects_funded_fall_due_amount) }})
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Cartera vencida (en proyectos)</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_03.projects_funded_percent_number) }}
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_02.projects_funded_percent_number) }}
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_01.projects_funded_percent_number) }}
                    </td>
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_acumulado.projects_funded_percent_number) }}
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Cartera vencida (en dinero)</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_03.projects_funded_percent_amount) }}
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_02.projects_funded_percent_amount) }}
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_01.projects_funded_percent_amount) }}
                    </td>
                    <td aria-colindex="1" role="cell" class="icon-circle">
                      {{ decimalPercentFormat(this.modelo_acumulado.projects_funded_percent_amount) }}
                    </td>
                  </tr>
                  <!---->
                  <!---->
                </tbody>
                <!---->
              </table>
            </div>
            <!---->
            <!---->
          </div>
        </div>
      </div>
      <div class="row m-3">
        <p class="col-md-4 col-sm-12 icon-circle"><strong>* Datos presentados al cierre del mes anterior.</strong></p>
        <p class="col-md-4 col-sm-12 icon-circle"><em class="fas fa-circle primary"></em><strong>Sistema
            Solar/Ecotecnologías</strong></p>
        <!-- <p class="col-md-3 col-sm-4 col-xs-6 icon-circle"><em class="fas fa-circle text-info"></em><strong>Instaladores
            (Capital de trabajo)</strong></p> -->
      </div>
      <div class="col-md-12">
        <div class="avivon-heading">
          <h3 class="text-left col-sm-12">Las <span class="primary">variables</span>. </h3>
          <p class="body-font1">
            Por otro lado, en la siguiente tabla podrás comparar cómo ha evolucionado el modelo conforme a las
            diferentes variables
            con las que se determina el grado de riesgo de los solicitantes. Estos se componen de características
            dinámicas,
            divididas en diferentes categorías e indicadores que se cuantifican para calificar al proyecto y al
            solicitante en una escala global.
          </p>
          <p class="avivon__desc offer-title2 mb-35px text-left col-sm-12"><strong>Para conocer más a detalle
              sobre estas variables da clic <a href="/calificacion">aquí</a>.</strong></p>
        </div>
        <!-- end avivon-heading -->
      </div>
      <div class="col-md-12">
          <div class="card card-table">
            <!---->
            <!---->
            <div class="mb-0 table-responsive">
              <table role="table" aria-busy="false" aria-colcount="5" class="table b-table">
                <caption aria-hidden="true" v-if="false">Cartera vencida</caption>
                <!---->
                <!---->
                <thead role="rowgroup" class="">
                  <!---->
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">

                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      Modelo 3
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3" class="">
                      Modelo 2
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="4" class="">
                      Modelo 1
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <!---->
                  <tr role="row" class="bg-row-header">
                    <td aria-colindex="1" role="cell" class="primary">
                      <strong class="primary">Controles de riesgo</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">

                    </td>
                    <td aria-colindex="3" role="cell" class="">

                    </td>
                    <td aria-colindex="4" role="cell" class="">

                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Evaluacion de proyecto</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Historial crediticio</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Comprobación de ingresos</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Situación jurídica</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">

                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">

                    </td>
                  </tr>
                  <tr role="row" class="bg-row-header">
                    <td aria-colindex="1" role="cell" class="primary">
                      <strong class="primary">Criterios de evaluación</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">

                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">

                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">

                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Indicadores de evaluación</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      42
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      24
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      14
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Variables consideradas</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      67
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      53
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      14
                    </td>
                  </tr>
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="">
                      <strong>Parametrización</strong>
                    </td>
                    <td aria-colindex="2" role="cell" class="icon-circle">
                      <em class="fas fa-check-circle primary"></em>
                    </td>
                    <td aria-colindex="3" role="cell" class="icon-circle">
                      
                    </td>
                    <td aria-colindex="4" role="cell" class="icon-circle">
                      
                    </td>
                  </tr>
                  <!---->
                  <!---->
                </tbody>
                <!---->
              </table>
            </div>
            <!---->
            <!---->
          </div>
        </div>
    </div>
  </section>
</template>

<script>
  import formatHelper from "@mixins/formatHelper";
  export default {
    name: "Body",
    mixins: [formatHelper],
    data: () => ({
      carteraVencida: '',
      modelo_01: {
        projects_funded_number: 0,
        projects_funded_amount: 0,
        projects_funded_fall_due_number: 0,
        projects_funded_fall_due_amount: 0,
        projects_funded_percent_number: 0,
        projects_funded_percent_amount: 0
      },
      modelo_02: {
        projects_funded_number: 0,
        projects_funded_amount: 0,
        projects_funded_fall_due_number: 0,
        projects_funded_fall_due_amount: 0,
        projects_funded_percent_number: 0,
        projects_funded_percent_amount: 0
      },
      modelo_03: {
        projects_funded_number: 0,
        projects_funded_amount: 0,
        projects_funded_fall_due_number: 0,
        projects_funded_fall_due_amount: 0,
        projects_funded_percent_number: 0,
        projects_funded_percent_amount: 0
      },
      modelo_acumulado: {
        projects_funded_number: 0,
        projects_funded_amount: 0,
        projects_funded_fall_due_number: 0,
        projects_funded_fall_due_amount: 0,
        projects_funded_percent_number: 0,
        projects_funded_percent_amount: 0
      },
    }),
    async beforeMount() {
      axios.get('/api/calculate-due-portfolio-stats').then((response) => {
 
        this.carteraVencida = response.data;

        let carteraVencidaMap = this.carteraVencida.map(e => e.model_version_id);

        let carteraVencida_15 = this.carteraVencida[carteraVencidaMap.indexOf(15)];
        let carteraVencida_16 = this.carteraVencida[carteraVencidaMap.indexOf(16)];
        let carteraVencida_14 = this.carteraVencida[carteraVencidaMap.indexOf(14)];
        let carteraVencida_08 = this.carteraVencida[carteraVencidaMap.indexOf(8)];
        let carteraVencida_13 = this.carteraVencida[carteraVencidaMap.indexOf(13)];

        if (typeof carteraVencida_15 !== 'undefined') {
          this.modelo_01.projects_funded_number += typeof carteraVencida_15.projects_funded_number === 'undefined' ? 0 : carteraVencida_15.projects_funded_number;
          this.modelo_01.projects_funded_amount += typeof carteraVencida_15.projects_funded_amount === 'undefined' ? 0 : carteraVencida_15.projects_funded_amount;
          this.modelo_01.projects_funded_fall_due_number += typeof carteraVencida_15.projects_funded_fall_due_number === 'undefined' ? 0 : carteraVencida_15.projects_funded_fall_due_number;
          this.modelo_01.projects_funded_fall_due_amount += typeof carteraVencida_15.projects_funded_fall_due_amount === 'undefined' ? 0 : carteraVencida_15.projects_funded_fall_due_amount;
        }
        if (typeof carteraVencida_16 !== 'undefined') {
          this.modelo_01.projects_funded_number += typeof carteraVencida_16.projects_funded_number === 'undefined' ? 0 : carteraVencida_16.projects_funded_number;
          this.modelo_01.projects_funded_amount += typeof carteraVencida_16.projects_funded_amount === 'undefined' ? 0 : carteraVencida_16.projects_funded_amount;
          this.modelo_01.projects_funded_fall_due_number += typeof carteraVencida_16.projects_funded_fall_due_number === 'undefined' ? 0 : carteraVencida_16.projects_funded_fall_due_number;
          this.modelo_01.projects_funded_fall_due_amount += typeof carteraVencida_16.projects_funded_fall_due_amount === 'undefined' ? 0 : carteraVencida_16.projects_funded_fall_due_amount;
        }
        this.modelo_01.projects_funded_percent_number += this.modelo_01.projects_funded_fall_due_number / this.modelo_01.projects_funded_number;
        this.modelo_01.projects_funded_percent_amount += this.modelo_01.projects_funded_fall_due_amount / this.modelo_01.projects_funded_amount;

        if (typeof carteraVencida_14 !== 'undefined') {
          this.modelo_02.projects_funded_number += typeof carteraVencida_14.projects_funded_number === 'undefined' ? 0 : carteraVencida_14.projects_funded_number;
          this.modelo_02.projects_funded_amount += typeof carteraVencida_14.projects_funded_amount === 'undefined' ? 0 : carteraVencida_14.projects_funded_amount;
          this.modelo_02.projects_funded_fall_due_number += typeof carteraVencida_14.projects_funded_fall_due_number === 'undefined' ? 0 : carteraVencida_14.projects_funded_fall_due_number;
          this.modelo_02.projects_funded_fall_due_amount += typeof carteraVencida_14.projects_funded_fall_due_amount === 'undefined' ? 0 : carteraVencida_14.projects_funded_fall_due_amount;
        }
        this.modelo_02.projects_funded_percent_number = this.modelo_02.projects_funded_fall_due_number / this.modelo_02.projects_funded_number;
        this.modelo_02.projects_funded_percent_amount = this.modelo_02.projects_funded_fall_due_amount / this.modelo_02.projects_funded_amount;

        if (typeof carteraVencida_08 !== 'undefined') {
          this.modelo_03.projects_funded_number += typeof carteraVencida_08.projects_funded_number === 'undefined' ? 0 : carteraVencida_08.projects_funded_number;
          this.modelo_03.projects_funded_amount += typeof carteraVencida_08.projects_funded_amount === 'undefined' ? 0 : carteraVencida_08.projects_funded_amount;
          this.modelo_03.projects_funded_fall_due_number += typeof carteraVencida_08.projects_funded_fall_due_number === 'undefined' ? 0 : carteraVencida_08.projects_funded_fall_due_number;
          this.modelo_03.projects_funded_fall_due_amount += typeof carteraVencida_08.projects_funded_fall_due_amount === 'undefined' ? 0 : carteraVencida_08.projects_funded_fall_due_amount;
        }
        if (typeof carteraVencida_13 !== 'undefined') {
          this.modelo_03.projects_funded_number += typeof carteraVencida_13.projects_funded_number === 'undefined' ? 0 : carteraVencida_13.projects_funded_number;
          this.modelo_03.projects_funded_amount += typeof carteraVencida_13.projects_funded_amount === 'undefined' ? 0 : carteraVencida_13.projects_funded_amount;
          this.modelo_03.projects_funded_fall_due_number += typeof carteraVencida_13.projects_funded_fall_due_number === 'undefined' ? 0 : carteraVencida_13.projects_funded_fall_due_number;
          this.modelo_03.projects_funded_fall_due_amount += typeof carteraVencida_13.projects_funded_fall_due_amount === 'undefined' ? 0 : carteraVencida_13.projects_funded_fall_due_amount;
        }
        this.modelo_03.projects_funded_percent_number = this.modelo_03.projects_funded_fall_due_number / this.modelo_03.projects_funded_number;
        this.modelo_03.projects_funded_percent_amount = this.modelo_03.projects_funded_fall_due_amount / this.modelo_03.projects_funded_amount;

        this.modelo_acumulado.projects_funded_number = 
          this.modelo_01.projects_funded_number + 
          this.modelo_02.projects_funded_number + 
          this.modelo_03.projects_funded_number;
        this.modelo_acumulado.projects_funded_amount = 
          this.modelo_01.projects_funded_amount + 
          this.modelo_02.projects_funded_amount + 
          this.modelo_03.projects_funded_amount;
        this.modelo_acumulado.projects_funded_fall_due_number = 
          this.modelo_01.projects_funded_fall_due_number + 
          this.modelo_02.projects_funded_fall_due_number + 
          this.modelo_03.projects_funded_fall_due_number;
        this.modelo_acumulado.projects_funded_fall_due_amount = 
          this.modelo_01.projects_funded_fall_due_amount +
          this.modelo_02.projects_funded_fall_due_amount + 
          this.modelo_03.projects_funded_fall_due_amount;
        this.modelo_acumulado.projects_funded_percent_number = 
          this.modelo_acumulado.projects_funded_fall_due_number / 
          this.modelo_acumulado.projects_funded_number;
        this.modelo_acumulado.projects_funded_percent_amount = 
          this.modelo_acumulado.projects_funded_fall_due_amount / 
          this.modelo_acumulado.projects_funded_amount;

      });
    },
    methods: {},
  }
</script>
<style>
  .bg-row-header {
    background-color:#EEEEEE;
  }

  /* .table>tbody>tr>td {
    font-size: 1.45rem;
  } */

  /* .avivon-heading .avivon__desc {
    font-size: 1.75rem;
  } */

  strong {
    color: #3B3A3E;
  }

  strong>a {
    color: #3B3A3E;
    text-decoration: underline;
  }
</style>